var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#7318FD",
  d: "M16 7.667A8.336 8.336 0 0 0 7.667 16c0 4.6 3.733 8.333 8.333 8.333S24.333 20.6 24.333 16 20.6 7.667 16 7.667m.833 12.5h-1.666v-5h1.666zm0-6.667h-1.666v-1.667h1.666z"
})));
export default SvgInfoBadge;